// FormCancelar.js — Formulario para cancelar la renovación (fase 8). Lo usan la
// página pública del enlace del recordatorio (con token) y «Mi suscripción» del
// perfil (con sesión). El acceso sigue hasta la fecha ya pagada.
import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { API_BASE_URL } from '../../services/api';

const CATEGORIAS_DEF = {
  precio: 'Es muy costoso', tiempo: 'No tengo tiempo', contenido: 'El contenido no es lo que buscaba',
  termine: 'Ya terminé lo que necesitaba', tecnico: 'Problemas técnicos', otro: 'Otro motivo',
};
export const fechaLarga = (iso) => (iso ? new Date(iso).toLocaleDateString('es-CO', { timeZone: 'America/Bogota', day: 'numeric', month: 'long', year: 'numeric' }) : '');

const Form = styled.form`
  --texto: ${p => (p.$oscuro ? '#c9d4e2' : '#475569')};
  --fuerte: ${p => (p.$oscuro ? '#fff' : '#0f172a')};
  --borde: ${p => (p.$oscuro ? 'rgba(255,255,255,.12)' : '#e2e8f0')};
  --suave: ${p => (p.$oscuro ? 'rgba(255,255,255,.05)' : '#f8fafc')};
  color: var(--texto);
  fieldset { border: 0; margin: 0 0 1rem; padding: 0; }
  legend { margin-bottom: .6rem; font-weight: 700; color: var(--fuerte); }
  .op { display: grid; grid-template-columns: repeat(auto-fit, minmax(210px, 1fr)); gap: .5rem; }
  label.r { display: flex; align-items: center; gap: .6rem; padding: .7rem .85rem; border-radius: 10px; cursor: pointer;
    background: var(--suave); box-shadow: inset 0 0 0 1px var(--borde); font-size: .92rem; }
  label.r:has(input:checked) { box-shadow: inset 0 0 0 2px ${p => p.$acento}; color: var(--fuerte); }
  input[type=radio] { accent-color: ${p => p.$acento}; width: 18px; height: 18px; margin: 0; }
  textarea { width: 100%; box-sizing: border-box; min-height: 90px; padding: .7rem .85rem; border-radius: 10px; border: 0; font: inherit; resize: vertical;
    background: var(--suave); color: var(--fuerte); box-shadow: inset 0 0 0 1px var(--borde); }
  textarea:focus { outline: none; box-shadow: inset 0 0 0 2px ${p => p.$acento}; }
  .nota { margin: .8rem 0 1.1rem; font-size: .88rem; }
  .botones { display: flex; gap: .6rem; flex-wrap: wrap; }
  button { height: 46px; padding: 0 1.3rem; border: 0; border-radius: 10px; font: inherit; font-weight: 700; cursor: pointer; }
  .peligro { background: #dc2626; color: #fff; }
  .peligro:disabled { opacity: .6; cursor: progress; }
  .sec { background: var(--suave); color: var(--fuerte); box-shadow: inset 0 0 0 1px var(--borde); }
  button:focus-visible { outline: 2px solid var(--fuerte); outline-offset: 2px; }
  .error { margin: 0 0 1rem; padding: .7rem .9rem; border-radius: 10px; background: rgba(239,68,68,.12); color: ${p => (p.$oscuro ? '#fecaca' : '#b91c1c')}; }
`;

const FormCancelar = ({ token, venceEn, categorias, tema = 'claro', acento = '#0f355b', onListo, onVolver }) => {
  const [cat, setCat] = useState('');
  const [motivo, setMotivo] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState('');
  const cats = categorias && Object.keys(categorias).length ? categorias : CATEGORIAS_DEF;

  const enviar = async (e) => {
    e.preventDefault();
    if (!cat) { setError('Elige el motivo principal.'); return; }
    setEnviando(true); setError('');
    try {
      const r = await axios.post(`${API_BASE_URL}/suscripcion-cancelar.php`, { t: token || undefined, categoria: cat, motivo });
      onListo?.(r.data);
    } catch (err) { setError(err.response?.data?.error || 'No pudimos cancelar. Inténtalo de nuevo o escríbenos.'); }
    setEnviando(false);
  };

  return (
    <Form onSubmit={enviar} $oscuro={tema === 'oscuro'} $acento={acento}>
      {error && <p className="error" role="alert">{error}</p>}
      <fieldset>
        <legend>¿Por qué cancelas?</legend>
        <div className="op">
          {Object.entries(cats).map(([k, t]) => (
            <label className="r" key={k}><input type="radio" name="cat" value={k} checked={cat === k} onChange={() => { setCat(k); setError(''); }} />{t}</label>
          ))}
        </div>
      </fieldset>
      <label>
        <span style={{ display: 'block', marginBottom: '.4rem', fontWeight: 600, color: 'var(--fuerte)' }}>¿Algo que quieras contarnos? <span style={{ fontWeight: 400 }}>(opcional)</span></span>
        <textarea value={motivo} onChange={e => setMotivo(e.target.value)} maxLength={500} />
      </label>
      <p className="nota">No se te volverá a cobrar. Conservas el acceso hasta el <b style={{ color: 'var(--fuerte)' }}>{fechaLarga(venceEn)}</b>, y tu avance y tus certificados quedan guardados.</p>
      <div className="botones">
        <button type="submit" className="peligro" disabled={enviando}>{enviando ? 'Cancelando…' : 'Cancelar renovación'}</button>
        {onVolver && <button type="button" className="sec" onClick={onVolver}>Mejor no</button>}
      </div>
    </Form>
  );
};

export default FormCancelar;
